var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect, _rect2, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSentToBroadcaster(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 100,
    viewBox: "0 0 110 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110 50C110 77.6142 64.1071 100 36.3878 100C8.6686 100 0 77.6142 0 50C0 22.3858 8.6686 0 36.3878 0C64.1071 0 110 22.3858 110 50Z",
    fill: "#F4F6F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3875 26.1137V48.6887C77.3875 50.6137 75.9 52.1012 73.975 52.1012H62.3375L53.85 57.7012V52.1012H50.7875C48.8625 52.1012 47.375 50.5262 47.375 48.6887V26.1137C47.375 24.1887 48.95 22.7012 50.7875 22.7012H73.975C75.8125 22.7012 77.3875 24.1887 77.3875 26.1137Z",
    fill: "#F4F6F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.025 22H22V23.75H33.025V22Z",
    fill: "#47B78E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3874 22H35.6499V23.75H42.3874V22Z",
    fill: "#47B78E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0625 27.6875H31.1875V29.4375H39.0625V27.6875Z",
    fill: "#47B78E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.65 27.6875H22V29.4375H28.65V27.6875Z",
    fill: "#47B78E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3625 33.4629H22V35.2129H31.3625V33.4629Z",
    fill: "#47B78E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3874 33.4629H33.8999V35.2129H42.3874V33.4629Z",
    fill: "#47B78E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9 39.1504H22V40.9004H33.9V39.1504Z",
    fill: "#47B78E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5618 65.3125H44.9243V67.0625H49.5618V65.3125Z",
    fill: "#34A7F0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8625 56.4746L69.6875 55.5996L68.025 55.9496L68.2 56.8246C68.2875 57.2621 68.2875 57.6996 68.2875 58.1371C68.2875 62.1621 65.05 65.3996 61.025 65.3996H53.0625V67.1496H61.025C66.0125 67.1496 70.0375 63.1246 70.0375 58.1371C70.0375 57.5246 69.95 56.9996 69.8625 56.4746Z",
    fill: "#34A7F0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3869 48.6875C30.2244 48.6875 26.0244 52.8875 26.0244 58.05C26.0244 63.2125 30.2244 67.4125 35.3869 67.4125C40.5494 67.4125 44.7494 63.2125 44.7494 58.05C44.7494 52.8875 40.5494 48.6875 35.3869 48.6875ZM32.6744 63.3V53.0625L40.3744 58.1375L32.6744 63.3Z",
    fill: "#34A7F0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M73.975 22H50.7C48.425 22 46.675 23.8375 46.675 26.025V44.6625H35.3875C28.0375 44.6625 22 50.7 22 58.05C22 65.4 28.0375 71.4375 35.3875 71.4375H55.425L65.3125 77.9125C65.4 78 65.575 78 65.6625 78C65.75 78 65.8375 78 65.925 77.9125C66.1 77.825 66.275 77.5625 66.275 77.3875V70.125C70.9125 67.9375 73.975 63.2125 73.975 58.05C73.975 56.125 73.5375 54.375 72.8375 52.7125H73.975C76.25 52.7125 78 50.875 78 48.6875V26.1125C78 23.8375 76.1625 22 73.975 22ZM65.3125 69.1625C65.05 69.25 64.875 69.6 64.9625 69.8625V76.25L55.95 70.3C55.8625 70.2125 55.6875 70.2125 55.6 70.2125H35.3875C28.7375 70.2125 23.3125 64.7875 23.3125 58.1375C23.3125 51.4875 28.7375 46.0625 35.3875 46.0625H46.675V48.775C46.675 51.05 48.5125 52.8 50.7 52.8H53.15V57.7C53.15 57.9625 53.2375 58.1375 53.5 58.225C53.5875 58.3125 53.675 58.3125 53.7625 58.3125C53.85 58.3125 54.025 58.3125 54.1125 58.225L62.425 52.7125H71.35C72.1375 54.2875 72.575 56.125 72.575 58.05C72.575 62.8625 69.775 67.2375 65.3125 69.1625ZM76.6875 48.6875C76.6875 50.2625 75.4625 51.4875 73.8875 51.4875H62.3375C62.25 51.4875 62.075 51.4875 61.9875 51.575L54.4625 56.475V52.1C54.4625 51.75 54.2 51.4875 53.85 51.4875H50.7875C49.2125 51.4875 47.9875 50.2625 47.9875 48.6875V26.1125C47.9875 24.5375 49.2125 23.3125 50.7875 23.3125H73.975C75.55 23.3125 76.775 24.5375 76.775 26.1125V48.6875H76.6875Z",
    fill: "#34A7F0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 28,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#EEECEC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 28,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#47B78E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M59 38L62.5 41L67.5 36",
    stroke: "#F4F6F8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9007 76.7773H30.3132C29.9632 76.7773 29.7007 77.0399 29.7007 77.3899C29.7007 77.7399 29.9632 78.0023 30.3132 78.0023H33.9007C34.2507 78.0023 34.5132 77.7399 34.5132 77.3899C34.5132 77.0399 34.2507 76.7773 33.9007 76.7773Z",
    fill: "#5E5E5E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4632 76.7773H38.1882C37.8382 76.7773 37.5757 77.0399 37.5757 77.3899C37.5757 77.7399 37.8382 78.0023 38.1882 78.0023H54.4632C54.8132 78.0023 55.0757 77.7399 55.0757 77.3899C55.0757 77.0399 54.8132 76.7773 54.4632 76.7773Z",
    fill: "#5E5E5E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentToBroadcaster);
export default __webpack_public_path__ + "static/media/sentToBroadcaster.3ccc16eeedd525be778bd881152e6689.svg";
export { ForwardRef as ReactComponent };